// map extracted fields to data view based on context type
import { mapBusinessCardExtractedFieldsToDataView } from "./mapBusinessCardExtractedFieldsToDataView";
import { mapCOIExtractedFieldsToDataView } from "./mapCOIExtractedFieldsToDataView";
import { mapDriversLicenseExtractedFieldsToDataView } from "./mapDriversLicenseExtractedFieldsToDataView";
import { mapResumeExtractedFieldsToDataView } from "./mapResumeExtractedFieldsToDataView";

import { DataItemProps } from "../../../../../../shared/components/DataView";
import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import {
  IAutoInsuranceExtractionResponse,
  IBusinessCardExtractionResponse,
  ICOIExtractionInterface,
  IDriversLicenseExtractionResponse,
  IResumeExtractionResponse
} from "@wingspanhq/shared-files/dist/lib/constants/extractions";

export const mapContextTypeExtractedFieldsToDataView = (
  extractedFields:
    | ICOIExtractionInterface
    | IDriversLicenseExtractionResponse
    | IBusinessCardExtractionResponse
    | IResumeExtractionResponse
    | IAutoInsuranceExtractionResponse
    | undefined,
  contextType: SharedFileRequestContextType | undefined
): DataItemProps[] => {
  switch (contextType) {
    case SharedFileRequestContextType.BusinessCard:
      return mapBusinessCardExtractedFieldsToDataView(
        extractedFields as IBusinessCardExtractionResponse
      );
    case SharedFileRequestContextType.DriversLicense:
      return mapDriversLicenseExtractedFieldsToDataView(
        extractedFields as IDriversLicenseExtractionResponse
      );
    case SharedFileRequestContextType.Resume:
      return mapResumeExtractedFieldsToDataView(
        extractedFields as IResumeExtractionResponse
      );
    case SharedFileRequestContextType.GeneralLiabilityCertificateOfInsurance:
      return mapCOIExtractedFieldsToDataView(
        extractedFields as ICOIExtractionInterface
      );
    case SharedFileRequestContextType.WorkersCompCertificateOfInsurance:
      return mapCOIExtractedFieldsToDataView(
        extractedFields as ICOIExtractionInterface
      );
    default:
      return [];
  }
};
